module.exports = __webpack_public_path__ + "static/media/p10.67cd2508.pdf";